/* eslint-disable */
// @ts-nocheck
// Dimensions contains mappings from druid dimensions to human readable names
import * as Dimensions from './dimensions';
export const { FILTER_DIMENSIONS, INSTALL_COHORT_DIMENSIONS, REENGAGEMENT_COHORT_DIMENSIONS, COHORT_USER_DATA_DIMENSIONS } =
  Dimensions;
// Datasources contains mappings from datasources to human readable names
import * as Datasources from './datasources';
export const {
  CORE_DATASOURCES,
  STANDARD_DATASOURCES,
  STANDARD_BLOCKED_DATASOURCES,
  CSV_EXPORT_DATASOURCES,
  DATASOURCES,
  DATASOURCES_IN_DEFAULT_CURRENCY,
  FRAUD_SPECIFIC_DATASOURCES,
  UNBLOCKED_FRAUD_DATASOURCES,
  ALL_FRAUD_DATASOURCES,
  COHORT_DATASOURCES,
  DEEPVIEWS_SUMMARY_SECTION_DATASOURCES,
  JOURNEYS_SUMMARY_SECTION_DATASOURCES,
  JOURNEYS_ANALYTICS_DATASOURCES,
  EMAIL_ANALYTICS_DATASOURCES,
  CLICK_FLOW_DATASOURCES,
  ATTRIBUTED_TOUCH_DATASOURCES,
  SKAN_DATASOURCES,
  SEO_DATASOURCES,
  TRUEVIEW_COLUMNS_DATASOURCES,
  OTT_DATASOURCES,
} = Datasources;
// maps calulated column header keys to human readable names
import * as CalculatedProperties from './calculated_properties';
export const {
  HOURS_FROM,
  FORMULAS,
  CURRENCY_FORMULAS,
  FRAUD_FROM_TOUCH_TO_EVENT,
  FRAUD_FORMULAS,
  FRAUD_TOTALS,
  FRAUD_GROUPS,
  EVENT_DESCRIPTIONS,
} = CalculatedProperties;
// maps druid  platform values to human readable names
import * as Platforms from './platforms';
export const { PLATFORMS } = Platforms;
// maps event names to datasources
import * as EventNames from './event_names';
export const {
  CORE_EVENT_NAMES,
  COHORT_CORE_EVENT_NAMES,
  COMMERCE_EVENT_NAMES,
  COMMERCE_EVENT_NAMES_WITH_LOCAL_CURRENCY,
  CONTENT_EVENT_NAMES,
  USER_LIFECYCLE_EVENT_NAMES,
  STANDARD_EVENT_NAMES_WITH_LOCAL_CURRENCY,
  STANDARD_EVENT_NAMES,
  STANDARD_EVENT_NAMES_BLOCKED,
  ALL_EVENT_NAMES,
  ALL_EVENT_NAMES_WITH_LOCAL_CURRENCY,
  CALCULATED_EVENT_NAMES,
  CURRENCY_EVENT_NAMES,
  CALCULATED_COST_EVENT_NAMES,
  CALCULATED_OTT_EVENT_NAMES,
  ADS_EVENTS_HUMAN_READABLE,
  BLOCKED_EVENTS_HUMAN_READABLE,
  LOCAL_CURRENCY_EVENTS_TO_HUMAN_READABLE,
  CALCULATION_TOPICS_TO_HUMAN_READABLE,
} = EventNames;
export * from './calculations';
// maps datasources to their sourceQuery
import * as SourceQueries from './source_queries';
import {
  REDOWNLOAD_DIMENSION,
  REDOWNLOAD_DIMENSION_MAPPING,
} from '../../../main/screens/ScreenSKAdNetwork/ScreenSKAdNetworkConstants';
export const {
  SOURCE_QUERIES,
  JOURNEYS_SUMMARY_TILE_SOURCE_QUERIES,
  JOURNEYS_SUMMARY_SECTION_SOURCE_QUERIES,
  DEEPVIEWS_SUMMARY_SECTION_SOURCE_QUERIES,
  CLICK_FLOW_SOURCE_QUERIES,
  EMAIL_SOURCE_QUERIES,
  ADS_TIMESERIES_SOURCE_QUERIES,
  QUICK_LINKS_SOURCE_QUERIES,
} = SourceQueries;
export const DATASOURCES_WITH_ALIASES = [
  'eo_user_lifecycle_event',
  'eo_commerce_event',
  'eo_content_event',
  'eo_custom_event',
];
const ALL_FRAUD = {
  ...FRAUD_FROM_TOUCH_TO_EVENT,
  ...FRAUD_FORMULAS,
  ...FRAUD_SPECIFIC_DATASOURCES,
  ...FRAUD_TOTALS,
  ...FRAUD_GROUPS,
  ...BLOCKED_EVENTS_HUMAN_READABLE,
};

/* ----------------------------------------------------------
 Use this to translate druid values to human readable values
------------------------------------------------------------ */
export const DRUID_TO_HUMAN_READABLE = {
  ...FILTER_DIMENSIONS,
  ...INSTALL_COHORT_DIMENSIONS,
  ...REENGAGEMENT_COHORT_DIMENSIONS,
  ...COHORT_DATASOURCES,
  ...DATASOURCES,
  ...FORMULAS,
  ...CURRENCY_FORMULAS,
  ...LOCAL_CURRENCY_EVENTS_TO_HUMAN_READABLE,
  ...HOURS_FROM,
  ...PLATFORMS,
  ...ALL_FRAUD,
  ...EVENT_DESCRIPTIONS,
  ...SKAN_DATASOURCES,
  ...OTT_DATASOURCES,
  ...CALCULATION_TOPICS_TO_HUMAN_READABLE,
};
export const CONDITIONAL_DRUID_TO_HUMAN_READABLE = {
  [REDOWNLOAD_DIMENSION]: REDOWNLOAD_DIMENSION_MAPPING,
};
